import { atomWithKey as atom } from "./atomWithKey";

export const isUpgradeToPremiumStateAtom = atom<boolean>({
    key: "isUpgradeToPremiumStateAtom",
    default: false
})
